import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerLocationDMSKeyloopConfig } from "models";
import type { AddEditLocationFormPayload } from "modules/DMSv3/Settings/components";

export type KeyloopConfig = Pick<DealerLocationDMSKeyloopConfig, "business_unit">;

type KeyloopConfigSectionProps = {
  index: number;
};

const FormHelper = createFormHelper<AddEditLocationFormPayload>();

export const KeyloopConfigSection = ({ index }: KeyloopConfigSectionProps) => {
  const { t } = useTranslation();

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_business_unit", "Business unit")} </label>
          <FormHelper.Field.ArrayInput fieldArrayName="dealer_location_dms" fieldKey="keyloop_config.business_unit" index={index} inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
